import { checkDate } from "common/helpers/Date";
import { Record } from "immutable";
import { DateStringNumber, Nullable } from "common/records";
import { TokenKind, TOKEN_KINDS } from "common/records/Token";

const isValidTokenKind = (kind: string): kind is TokenKind => {
  return TOKEN_KINDS.includes(kind as TokenKind);
};

export const integrationErrorFromJSON = (json: Partial<IIntegrationErrorData>): IntegrationErrorRecord => {
  const recordData: IIntegrationErrorRecord = { ...defaultIntegrationErrorProps, ...json } as IIntegrationErrorRecord;

  if (json.token_kind) {
    if (isValidTokenKind(json.token_kind)) {
      recordData.token_kind = json.token_kind;
    } else {
      // If invalid, fall back to default
      recordData.token_kind = defaultIntegrationErrorProps.token_kind;
    }
  }

  if (json.created_at) {
    recordData.created_at = checkDate(json.created_at);
  }

  if (json.updated_at) {
    recordData.updated_at = checkDate(json.updated_at);
  }

  return new IntegrationErrorRecord(recordData);
};

export interface IIntegrationErrorData {
  id: string;
  org_uuid: string;
  token_kind: string | TokenKind;
  error_class: string;
  error_message: string;
  error_trace: Nullable<string>;
  data: any;
  created_at: DateStringNumber;
  updated_at: DateStringNumber;
}

export interface IIntegrationErrorRecord {
  id: string;
  org_uuid: string;
  token_kind: TokenKind;
  error_class: string;
  error_message: string;
  error_trace: Nullable<string>;
  data: any;
  created_at: Date;
  updated_at: Date;
}

export const defaultIntegrationErrorProps: IIntegrationErrorRecord = {
  id: "",
  org_uuid: "",
  token_kind: "salesforce",
  error_class: "",
  error_message: "",
  error_trace: null,
  data: {},
  created_at: new Date(),
  updated_at: new Date(),
};

export class IntegrationErrorRecord extends Record(defaultIntegrationErrorProps) implements IIntegrationErrorRecord {}
